import {isArray, Type} from '../common';
import {IGenerator, IGeneratorMeta} from './generator';

/**
 *  数据源生成器库
 *  1、注册or批量注册数据源生成器
 *  2、根据数据源生成器id，获取数据源生成器实例
 *  3、根据数据源生成器id，获取数据源生成器定义
 *
 *  数据源生成器库实例不依赖于具体的可视化报告，被创建后一直存在，所以没有destroy方法
 */
export class GeneratorRepository {

  private _generatorMap: Map<string, IGeneratorMeta> = new Map();

  /**
   * 数据源生成器库编号
   * 数据源生成器库名称
   * @param _id
   * @param _name
   */
  constructor(private _id: string, private _name: string) {

  }

  get id(): string {
    return this._id;
  }

  get name(): string {
    return this._name;
  }

  has(generatorID: string) {
    return this._generatorMap.has(generatorID);
  }

  register(meta: IGeneratorMeta) {
    if (meta) {
      this._generatorMap.set(meta.id, meta);
    }
  }

  batchRegister(metaArray: Array<IGeneratorMeta>) {
    if (isArray(metaArray)) {
      metaArray.forEach((value) => {
        this.register(value);
      });
    }
  }

  /**
   * 获得数据源生成器实例
   * @param generatorID
   */
  getGenerator(generatorID: string): IGenerator {
    if (this._generatorMap.has(generatorID)) {
      const meta = this._generatorMap.get(generatorID);
      return meta.generator || (meta.generator = new meta.generatorDef());
    }
  }

  /**
   * 获得数据源生成器类
   * @param generatorID
   */
  getGeneratorDef(generatorID: string): Type<IGenerator> {
    if (this._generatorMap.has(generatorID)) {
      return this._generatorMap.get(generatorID).generatorDef;
    }
  }

  get meta(): Array<{ label: string, value: string, id: string, name: string }> {
    return Array.from(this._generatorMap.entries()).map(([key, value], index) => {
      return {
        label: key,
        id: this._id,
        name: this._name,
        value: this._id + '$' + key
      };
    });
  }
}
